
import React from "react";

import { connect } from 'react-redux';

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { editUserData } from "actions";
import ChangePasswordModal from "components/moreComponents/ChangePasswordModal";

class User extends React.Component {
  state = {
    email:this.props.auth.email,
    username:this.props.auth.username,
    age:this.props.auth.age,
    rest_hr:this.props.auth.rest_hr,
    max_hr:this.props.auth.max_hr,
    lactate_th:this.props.auth.lactate_th,
    lactate_th:this.props.auth.lactate_th,
    lactate_cycle:this.props.auth.lactate_cycle,
    lactate_swim:this.props.auth.lactate_swim,
    male:this.props.auth.male,
    measurementSystem:this.props.auth.measurementSystem

  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
          email: this.props.auth.email,
          username: this.props.auth.username,
          age: this.props.auth.age,
          rest_hr:this.props.auth.rest_hr,
          max_hr:this.props.auth.max_hr,
          lactate_th:this.props.auth.lactate_th,
          lactate_cycle:this.props.auth.lactate_cycle,
          lactate_swim:this.props.auth.lactate_swim,
          male:this.props.auth.male,
          measurementSystem:this.props.auth.measurementSystem
    });
  }

  componentDidUpdate(){
    console.log(this.props.auth.email)
  }

  saveChanges(){
    this.props.editUserData(this.state)
    
  }
  render() {
    if(this.props.message.message){
      if (this.props.message.message[1] =="user data was updated"){
        window.location.replace('/dashboard')
      }
    }
    
    console.log("state",this.state,"redux",this.props.auth)
    return (
      <>
        <PanelHeader size="sm" />
        <div className="content">
          <Row>
            <Col md="12">
              <Card >
                <CardHeader>
                  <h5 className="title">User Profile</h5>
                </CardHeader>
                <CardBody>
                  <Form>
                    <Row>
                      <Col className="pr-1" md="5">
                        <FormGroup>
                          <label></label>
                          <Input
                            value={this.state.email}
                            disabled
                            
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                      <Col className="px-1" md="6">
                        <FormGroup>
                          <label>Username</label>
                          <Input
                            value={this.state.username}
                            type="text"
                            onChange={e => this.setState({username:e.target.value})}
                          />
                        </FormGroup>
                      </Col>
                      
                    </Row>
                    <Row>
                      <Col className="pr-1" md="6">
                        <FormGroup>
                          <label>Password</label>
                          <ChangePasswordModal />
                        </FormGroup>
                      </Col>
                      <Col className="pl-1" md="6">
                        <FormGroup>
                          <label>Age</label>
                          <Input type="number" value={this.state.age} onChange={e => this.setState({age:e.target.value})}/>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <label>Rest Heart rate</label>
                          <Input type="number" value={this.state.rest_hr} onChange={e => this.setState({rest_hr:e.target.value})}/>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pr-1" md="4">
                        <FormGroup>
                          <label>Maximum Heart Rate</label>
                          <Input type="number" value={this.state.max_hr} onChange={e => this.setState({max_hr:e.target.value})}/>
                        </FormGroup>
                      </Col>
                      <Col className="px-1" md="4">
                        <FormGroup>
                          <label>Lactate Threshold Run</label>
                          <Input type="number" value={this.state.lactate_th} onChange={e => this.setState({lactate_th:e.target.value})}/>
                        </FormGroup>
                        <FormGroup>
                          <label>Lactate Threshold Ride</label>
                          <Input type="number" value={this.state.lactate_cycle} onChange={e => this.setState({lactate_cycle:e.target.value})}/>
                        </FormGroup>
                        <FormGroup>
                          <label>Lactate Threshold Swim</label>
                          <Input type="number" value={this.state.lactate_swim} onChange={e => this.setState({lactate_swim:e.target.value})}/>
                        </FormGroup>
                      </Col>
                      <Col className="pl-1" md="4">
                        <FormGroup>
                          <label>Metrics</label>
                          <Input type="select" value={this.state.male} onChange={e => this.setState({male:e.target.value})}>
                            <option value ={true}>Male</option>
                            <option value ={false}>Female</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <label>Metrics</label>
                          <Input type="select" value={this.state.measurementSystem} onChange={e => this.setState({measurementSystem:e.target.value})}>
                            <option value ='Metric km/hr'>Metric km/hr</option>
                            <option value ='Metric min/km'>Metric min/km</option>
                            <option value ='Imperial mile/hr'>Imperial mile/hr</option>
                            <option value ='Imperial min/mile'>Imperial min/mile</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                  <Button color='info' onClick={this.saveChanges.bind(this)}>Save Changes</Button>
                </CardBody>
              </Card>
            </Col>
            
          </Row>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {auth:state.auth,message:state.message}
}

export default connect(mapStateToProps,{editUserData})(User);
